module.exports = __webpack_public_path__ + "static/media/clear.1626f4bc.svg";